var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    rx: 30,
    fill: "#A6C6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.4379 126.423V166.26C84.4379 202.331 113.694 231.572 149.784 231.572C185.873 231.572 215.13 202.331 215.13 166.26V126.423V50H233.568V166.26C233.568 212.508 196.056 250 149.784 250C103.511 250 66 212.508 66 166.26V50H84.4379V126.423Z",
    fill: "#E8F3FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.94 115.041V164.905C122.94 179.274 134.594 190.921 148.97 190.921C163.346 190.921 175 179.274 175 164.905V115.041V85.2303H193.438V164.905C193.438 189.451 173.529 209.35 148.97 209.35C124.411 209.35 104.503 189.451 104.503 164.905V85.2303H122.94V115.041Z",
    fill: "#E8F3FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1164 50L149.516 109.025L207.995 50.0033L233.511 50L233.521 50.01L149.523 135.093L66.0551 50H92.1164V50Z",
    fill: "#E8F3FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefault);
export default __webpack_public_path__ + "static/media/icon-default.ce0fcd03d612fa8e40a058b2c5fb44e9.svg";
export { ForwardRef as ReactComponent };